import React from 'react';
import { Link } from 'react-router-dom';
interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}
interface FooterColumn {
  title: string;
  links: FooterLink[];
}
const columns: FooterColumn[] = [{
  title: 'Solutions',
  links: [{
    label: 'For Brands',
    to: '/for-brands'
  }, {
    label: 'For Marketing Agencies',
    to: '/for-marketing-agencies'
  }, {
    label: 'For Talent Agencies',
    to: '/list-your-roster'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'Home',
    to: '/'
  }, {
    label: 'Case Studies',
    to: '/case-studies'
  }, {
    label: 'Pricing',
    to: '/pricing'
  }, {
    label: 'Login',
    href: 'https://app.zanoplatform.com/sign-in'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Privacy Policy',
    to: '/privacy-policy'
  }, {
    label: 'Terms of Service',
    to: '/terms-of-service'
  }, {
    label: 'Cookie Policy',
    to: '/cookie-policy'
  }]
}, {
  title: 'Contact',
  links: [{
    label: 'support@zanoplatform.com',
    href: 'mailto:support@zanoplatform.com'
  }]
}];
const linkClass = 'text-sm text-gray-500 hover:text-zano-pink transition-colors';
export const Footer = () => {
  return <footer className="bg-white border-t border-gray-100 pt-14 pb-10" data-id="element-427" data-mp="817dm6kejqu2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-428" data-mp="32vyphf92q4z">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 gap-y-10" data-id="element-429" data-mp="hsk1yo6zryvc">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-430" data-mp="cu0geowb8p3i">
            <Link to="/" className="inline-flex items-center" data-id="element-431" data-mp="cu8qk911tgb0">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-6 w-auto" data-id="element-432" data-mp="qsqea6qyessx" />
            </Link>
            <p className="mt-4 text-sm text-gray-500 leading-relaxed max-w-xs" data-id="element-433" data-mp="twfmxpvnlpqb">
              The discovery layer for represented creators.
            </p>
          </div>

          {/* Link columns */}
          {columns.map(col => <nav key={col.title} aria-label={col.title} data-id="element-434" data-mp="13rfzcr4x5ryx">
              <h3 className="text-xs font-semibold uppercase tracking-wider text-zano-charcoal mb-4" data-id="element-435" data-mp="18ksmsxxv3sq3">
                {col.title}
              </h3>
              <ul className="space-y-3" data-id="element-436" data-mp="1hkp42ehx9pb4">
                {col.links.map(link => <li key={link.label} data-id="element-437" data-mp="1hmie83rqurnv">
                    {link.to ? <Link to={link.to} className={linkClass} data-id="element-438" data-mp="1mkjwwnl9coyt">
                        {link.label}
                      </Link> : <a href={link.href} target={link.href?.startsWith('http') ? '_blank' : undefined} rel={link.href?.startsWith('http') ? 'noopener noreferrer' : undefined} className={`${linkClass} break-words`} data-id="element-439" data-mp="3obokn8k2l5dv">
                        {link.label}
                      </a>}
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 text-sm text-gray-400" data-id="element-440" data-mp="2pce9pf2fr1mq">
          © {new Date().getFullYear()} Zano. All rights reserved.
        </div>
      </div>
    </footer>;
};